
import { Component, Vue, Prop, Watch, Emit, Ref, Mixins } from 'vue-property-decorator'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import CityListGird from '../components/CityListGird/index.vue'
import { MixinsHomeClick } from '@xt/client/mixins/home'
import { Observer } from 'mobx-vue'
import type { ClickEvent } from '@xt/client/types/home'
import ConfirmModal from '../components/ConfirmModal/index.vue'
import InitConfirmModal from '../components/InitConfirmModal/index.vue'
import type { ModalDataType, ConfirmModalOptions } from '@xt/client/entities/kindred-spirit/kindred-spirit'

@Observer
@Component({
  components: {
    NewSwiper,
    CityListGird,
    ConfirmModal,
    InitConfirmModal
  },
  async asyncData(ctx) {
    await ctx.store.$homeV2.loadJSON()
  }
})
export default class CityListPage extends Mixins(MixinsHomeClick) {
  initConfirmModalData: ModalDataType = {
    cityName: '',
    adcode: 0
  }

  @Ref()
  confirmModal: {
    show: (options: ConfirmModalOptions) => void
    hide: () => void
  }

  @Ref()
  initConfirmModal: {
    show: (options?: ConfirmModalOptions) => void
  }

  @Ref()
  swiper: {
    handlePrev: () => void
    handleNext: () => void
  }

  get TonghaoStore() {
    return this.$store.$tonghao
  }

  get PageStore() {
    return this.$store.$tonghao.Cities
  }

  get HomeStore() {
    return this.$store.$homeV2
  }

  handleInitSelect(value) {
    this.TonghaoStore.initTonghao()
  }

  openAssistantModal(
    data: ModalDataType = {
      cityName: '杭州',
      adcode: 330100
    }
  ) {
    this.confirmModal.show({
      title: `为${data.cityName}分桐助力`,
      description: '助力后将自动加入该分桐，并增加分桐热力值。达到目标后可推进分桐开放。',
      layoutClassName: 'assistant-confirm-modal',
      confirmedHide: true,
      confirmText: '立即助力',
      cancelText: '稍后再说',
      backgroundUrl: this.$store.$global.static + '/images/topic/pc/assistant-pop-bg.png',
      onOk: async () => {
        this.initConfirmModalData = data

        await this.PageStore.loadCascadeCities()

        // this.initConfirmModal.show({
        //   title: `发起${data.cityName}分桐`,
        //   layoutClassName: 'init-confirm-modal',
        //   confirmedHide: true,
        //   confirmText: '立即创建',
        //   cancelText: '稍后再说',
        //   backgroundUrl: this.$store.$global.static + '/images/topic/pc/init-pop-bg.png',
        //   onOk: () => {
        //     this.$msg('敬请期待~')

        //     this.openImproveModal()
        //   }
        // })
      }
    })
  }

  openRecruitModal(
    data: ModalDataType = {
      cityName: '杭州',
      adcode: 330100
    }
  ) {
    this.confirmModal.show({
      title: `成为${data.cityName}分桐负责人`,
      description: `报名参与负责人招募，即视为您已自动加入该分桐。待负责人招募工作全部完成后，${data.cityName}分桐将正式开放。`,
      layoutClassName: 'recruit-confirm-modal',
      confirmedHide: true,
      confirmText: '确认',
      cancelText: '再想想',
      backgroundUrl: this.$store.$global.static + '/images/topic/pc/recruit-pop-bg.png',
      onOk: () => {
        this.$msg('敬请期待~')
      }
    })
  }

  openJoinModal(
    data: ModalDataType = {
      cityName: '杭州',
      adcode: 330100
    }
  ) {
    this.confirmModal.show({
      title: `${data.cityName}分桐`,
      description: '桐学仅可选择一座常住城市加入，与桐好笔墨相伴，雅会常聚。',
      layoutClassName: 'join-confirm-modal',
      confirmedHide: true,
      confirmText: '确认加入',
      cancelText: '再想想',
      backgroundUrl: this.$store.$global.static + '/images/topic/pc/assistant-pop-bg.png',
      onOk: () => {
        this.$msg('敬请期待~')
      }
    })
  }

  openInitModal() {
    this.initConfirmModal.show()
  }

  prev() {
    if (!this.swiper) return
    this.swiper.handlePrev()
  }

  next() {
    if (!this.swiper) return
    this.swiper.handleNext()
  }

  handleToIntro() {
    if (this.HomeStore.citiesJsonData?.event) {
      this.onClickEvent(this.HomeStore.citiesJsonData.event)
      return
    }
  }

  handleCardClick(item: { cover: string; event?: ClickEvent }) {
    if (item.event) {
      this.onClickEvent(item.event)
      return
    }
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
